import { useState, createContext, useContext, useMemo, ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { useSessionStorage } from 'react-use';
import { SearchProcessingUsersResponse } from './api';
import { ProcessingUser } from './types';

type ContextValue =
  | (ProcessingUser & {
      setSelected: (user: ProcessingUser) => void;
    })
  | {
      setSelected: (user: ProcessingUser) => void;
    };

const Context = createContext<ContextValue>({
  setSelected: () => undefined,
});

export const useSetSelected = () => {
  const { setSelected } = useContext(Context);
  return setSelected;
};

export const useSelected: () => ProcessingUser | null = () => {
  const context = useContext(Context);

  const processingUser = useMemo(() => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { setSelected, ...rest } = context;
    return rest;
  }, [context]);

  return Object.keys(processingUser).length > 0
    ? (processingUser as ProcessingUser)
    : null;
};

export const SelectedProcessingUserProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const params = useParams();
  const [value] = useSessionStorage<SearchProcessingUsersResponse | null>(
    'qbProcessingUserSearchResult'
  );
  const defaultUser =
    value?.processingUsers.filter((u) => u.userId === params['*'])[0] ?? null;
  const [processingUser, setProcessingUser] = useState<ProcessingUser | null>(
    defaultUser
  );

  const context = useMemo(() => {
    return { ...processingUser, setSelected: setProcessingUser };
  }, [processingUser]);

  return <Context.Provider value={context}>{children}</Context.Provider>;
};
